module.exports = __webpack_public_path__ + "img/new-equipment-1.d509654d.png";